<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'ComplaintFeedback' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Overall Feedback</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container reaction-box">
        <div>
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="jbl-rating-img">
                <img :src="imgPath" id="RatingImage" alt="Rating Image">
              </div>
              <div>
                <h1 class="jbl-rating-heaing" style="text-align: center;">Rate Your Experience </h1>
                <h3 class="mt-4 mb-4 jbl-rating-subheading" v-if="exp_title != ''">{{ exp_title }} Experience!</h3>
                <form v-on:submit="OverAllFeedBack" id="OverAllFeedBack">
                  <div class="rating">
                    <input type="radio" name="rating" value="5" id="5" required @click="ChangeExperience(1)"><label for="5"><i class="fa fa-star"></i></label>
                    <input type="radio" name="rating" value="4" id="4" required @click="ChangeExperience(2)"><label for="4"><i class="fa fa-star"></i></label>
                    <input type="radio" name="rating" value="3" id="3" required @click="ChangeExperience(3)"><label for="3"><i class="fa fa-star"></i></label>
                    <input type="radio" name="rating" value="2" id="2" required @click="ChangeExperience(4)"><label for="2"><i class="fa fa-star"></i></label>
                    <input type="radio" name="rating" value="1" id="1" required @click="ChangeExperience(5)"><label for="1"><i class="fa fa-star"></i></label>
                  </div>
                  <div>
                    <div class="jbl-field">
                      <textarea type="text" class="jbl-dynamic-input" style="height: 125px !important;" placeholder="Your Comments"></textarea>
                    </div>
                  </div>
                  <div class="d-block text-center">
                    <button type="submit" class="ib-btn-primary ib-btn-width mx-auto text-uppercase">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'Complaint',
    components: {
      loading
    },
    data() {
      return {
        showLoader: false,
        self_claims: {},
        nominated_claims: {},
        self: {},
        nominated: {},
        customer_self_policies: {},
        customer_nominated_policies: {},
        customer_self_policies_filterd: {},
        customer_nominated_policies_filterd: {},
        custom_fields: {},
        self_claim_area: true,
        nominated_claim_area: false,
        self_claims_area: true,
        nominated_claims_area: false,
        current_state: "self",
        current_states: "self",
        type: 0,
        id: 0,
        showFeedbackModal: false,
        exp_title : '',
        imgPath : require('@/assets/images/normal.svg'),
      };
    },
    created: function () {
    },
    methods: {
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async OverAllFeedBack(e) {
        e.preventDefault();
        const self = this;
        self.showLoader = true;
        var formData = new FormData(document.getElementById('OverAllFeedBack'));

        await axios.post("customer/feedback/store_app_feedback", formData).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code === 200) {
            $toast.info(resp.data.message, { position: 'top-right' });
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      ChangeExperience(value) {
        const self = this;
        if (value == 5) {
          self.imgPath = require('@/assets/images/very_bad.svg');
          self.exp_title = 'Very Bad';
        } else if(value == 4) {
          self.imgPath = require('@/assets/images/bad.svg');
          self.exp_title = 'Bad';
        } else if(value == 3) {
          self.imgPath = require('@/assets/images/normal.svg');
          self.exp_title = 'Nice';
        } else if(value == 2) {
          self.imgPath = require('@/assets/images/good.svg');
          self.exp_title = 'Good';
        } else {
          self.imgPath = require('@/assets/images/very_good.svg');
          self.exp_title = 'Very Good';
        }
      }
    }
  };
</script>

<style scoped>
  .rating {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    margin-bottom: 2.8rem;
  }
  .rating > input {
    display: none;
  }
  .rating > label {
    position: relative;
    width: 3.8rem;
    font-size: 3rem;
    color: #e8e8e8;;
    cursor: pointer;
    margin: 3px;
  }
  .rating > label::before {
    content: "\f005";
    position: absolute;
    opacity: 0;
    font-family: 'FontAwesome' !important;
    font-size: 46px !important;
  }
  .rating > label:hover:before,
  .rating > label:hover ~ label:before {
    opacity: 1 !important;
    color: var(--primary-color);
    font-size: 3.5rem;
    left: 1px;
    top: -1px;
  }
  .rating > input:checked ~ label:before {
    opacity: 1;
    color: var(--primary-color);
    font-size: 3.5rem;
    left: 1px;
    top: -1px;
  }
  .rating:hover > input:checked ~ label:before {
    opacity: 0.4;
    color: var(--primary-color);
    font-size: 3.5rem;
    left: 1px;
    top: -1px;
  }
  @media(max-width:420px) {
    .rating > label {
      font-size: 2rem;
    }
    .rating > label::before {
      font-family: "Font Awesome";
      font-size: 3rem;
    }
    .rating > label:hover:before,
    .rating > label:hover ~ label:before {
      font-size: 2.5rem;
      left: 1px;
      top: -1px;
    }
    .rating > input:checked ~ label:before {
      font-size: 2.5rem;
      left: 1px;
      top: -1px;
    }
    .rating:hover > input:checked ~ label:before {
      font-size: 2.5rem;
      left: 1px;
      top: -1px;
    }
  }
  .nav-pills .nav-item .active {
    box-shadow: 0 8px 66px 0 rgba(0, 0, 0, 0.21);
    border: solid 2px #ba0c2f;
    background-color: #ffffff;
  }
  .nav-pills .nav-item .nav-link p {
    margin: 10.5px 0 0;
  }
  .nav-pills .nav-item .nav-link {
    width: 180px;
    height: 170px;
    margin: 0 18px;
    padding: 27.2px 57px 20px;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    color: #5b6770;
  }
  h1 {
    font-family: "Futura PT";
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    text-align: left;
    color: #ba0c2f;
  }
  .data-row p {
    color: #5b6770;
  }
  table > tbody > tr,
  .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,
  .data-row .data-img img {
    width: 74px;
    height: 48px;
    border-radius: 7px;
  }
  .input-placeholder:focus ~ label,
  .input-placeholder:valid ~ label {
    font-size: 11px;
    left: 10px;
    top: -10px;
  }
  .input-placeholder:valid ~ label {
    color: green;
  }
  .input-placeholder:focus:invalid ~ label {
    color: red;
  }
  @media (max-width: 668px) {
    .data-img img {
      width: 60%;
      height: auto;
      padding: 0.5rem;
    }
  }
  .nav-pills .nav-item .active {
    box-shadow: 0 8px 66px 0 rgba(0, 0, 0, 0.21);
    border: solid 2px #ba0c2f;
    background-color: #ffffff;
  }
  .nav-pills .nav-item .nav-link p {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: center;
    color: #5b6770;
  }
  .nav-pills .nav-item .nav-link {
    width: 140px;
    height: 140px;
    margin: 0 7px;
    padding: 0.5rem !important;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    color: #5b6770;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .nav-pills .nav-item .nav-link img {
    margin-top: 0.5rem;
  }
  @media (max-width: 480px) {
    .nav-pills .nav-item .nav-link {
      width: 110px;
      height: 110px;
    }
    .nav-pills .nav-item .nav-link img {
      width: 70%;
      height: auto;
    }
    .nav-pills .nav-item .nav-link p {
      font-size: 12px;
    }
  }
  .jbl-rating-heaing {
    font-family: "Avenir Medium";
    font-size: 20px;
    /* font-weight: 900; */
    letter-spacing: -0.01px;
    text-align: center;
    color: #5b6770;
    padding-top: 1.5rem;
  }
  .jbl-rating-subheading {
    font-family: "Avenir Medium";
    font-size: 39px;
    font-weight: 500;
    letter-spacing: -0.01px;
    text-align: center;
    color: #845bb3;
  }
  .jbl-rating-img {
    position: relative;
    text-align: center;
    top: 0.6rem;
    z-index: 1;
  }
  .rating-status img {
    max-width: 55px;
  }
  @media(max-width:420px) {
    .rating-status img {
      max-width: 45px;
    }
  }
  .radio-width-img img {
    width: 5rem;
    margin-left: .4rem;
    margin-right: .4rem;
  }
  @media (max-width:480px) {
    .radio-width-img img {
      width: 3.8rem;
      margin-left: .3rem;
      margin-right: .3rem;
    }
  }
  @media (max-width:420px) {
    .radio-width-img img {
      width: 3.2rem;
      margin-left: .3rem;
      margin-right: .3rem;
    }
  }
  @media (min-width: 786px) {
    .radio-width-img img {
      width: 7rem;
      margin-left: .4rem;
      margin-right: .4rem;
    }
  }
  label{
    font-size: 46px !important;
  }
  label::before{
    position: absolute !important;
    left: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Feedback/Overall.vue